import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Config {
  url?: string;
  urlImagem?: string;
  urlRelativa?: string;
  exibirMenu: boolean;
  exibirRodape: boolean;
  ajudaParaInstalacao: boolean;
}

const inicial: Config = {
  exibirMenu: true,
  exibirRodape: true,
  ajudaParaInstalacao: true,
};

export const config = createSlice({
  name: 'config',
  initialState: inicial,
  reducers: {
    carregar: (estado, acao: PayloadAction<Config>) =>
      (estado = { ...estado, ...acao.payload }),
    alternarInterface: (estado) => {
      estado.exibirMenu = !estado.exibirMenu;
      estado.exibirRodape = !estado.exibirRodape;
    },
    ocultarAjudaParaInstalacao: (estado) => {
      estado.ajudaParaInstalacao = false;
    },
  },
});

export const { carregar, alternarInterface, ocultarAjudaParaInstalacao } = config.actions;

export default config.reducer;
